var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-container"},[_c('div',{staticClass:"mobile-logo"},[_c('img',{staticClass:"logo-mobile",attrs:{"src":require("@/assets/weipu.png"),"alt":""}})])])
}]

export { render, staticRenderFns }